import type {ReactElement} from 'react';
import {createElement} from 'react';
import type {EmailMakerControl, EmailMakerControlProps} from '../../right-panel-registry.types';
import type {WrapperBorderControls} from './wrapper-border-control.types';
import styles from './wrapper-border-control.module.scss';

/**
 * Groups border style/color/thickness into one mobile sheet. The bottom bar re-renders only on
 * selection (not style changes), so color/thickness can't be live-gated as standalone tiles.
 */
export function makeWrapperBorderControl(controls: WrapperBorderControls): EmailMakerControl {
  return function WrapperBorderControl({component, hideSectionHeading}: EmailMakerControlProps): ReactElement {
    return (
      <div className={styles.group}>
        {createElement(controls.styleControl, {component, hideSectionHeading})}
        {createElement(controls.colorControl, {component, hideSectionHeading})}
        {createElement(controls.widthControl, {component, hideSectionHeading})}
      </div>
    );
  };
}
